/**
 * Formats a Unix timestamp into a localized date string
 * @param {number|string} unixTime - Unix timestamp in seconds
 * @returns {string} Formatted date string or empty string if invalid input
 */
export const formatUnixTimestampToHumanReadableFormat = (unixTime) => {
    if (!unixTime || unixTime === undefined) {
        return "";
    }
    return new Date(Number(unixTime) * 1000).toLocaleString();
}; 